import React from 'react';
import type { TFunction } from 'react-i18next';
import Cookies from 'js-cookie';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { LoginType, SubPackageSlugEnum } from '@yaotai/common-utils';

export enum RegisterResultStatus {
  ERROR = 'error',
  REPEAT = 'repeat',
  SUCCESS = 'success',
}

export type PhoneMsgCodeInfo = {
  aid: string;
  phone: string;
  region: string;
  valid: string;
};

export enum MailRegisterType {
  UrsMail = 'ursMailRegister',
  RbacMail = 'rbacMailRegister',
}

export type LoginRegisterType = LoginType | MailRegisterType;

export const titleMap = new Map<
  string,
  (t: TFunction, right?: boolean) => { extra?: React.ReactNode; title?: React.ReactNode }
>([
  [LoginType.Phone, (t: TFunction) => ({ title: t('login.toPhone') })],
  [
    LoginType.NetEaseMail,
    (t, right) => ({
      title: <>{t('login.UseEmailLogin')}</>,
      extra: (
        <>
          {!right && <LeftOutlined />} {t('login.OtherLoginMethods')} {right && <RightOutlined />}
        </>
      ),
    }),
  ],
  [
    LoginType.CommonMail,
    (t, right) => ({
      title: <>{t('login.UseEmailLogin')}</>,
      extra: (
        <>
          {!right && <LeftOutlined />} {t('login.OtherLoginMethods')} {right && <RightOutlined />}
        </>
      ),
    }),
  ],
  [
    MailRegisterType.UrsMail,
    (t, right) => ({
      title: <>{t('registration.createAccount')}</>,
    }),
  ],
]);

export const otherLogin = (domain: string, login: string, next?: string) => {
  Cookies.remove('RBAC_TOKEN', { path: '/', domain });
  Cookies.remove('RBAC_USER', { path: '/', domain });
  window.location.href = `${window.location.origin}/${SubPackageSlugEnum.Center}${login}?next=${next || ''}`;
};
